/** Document-intelligence palette — sky investigation, indigo control, amber evidence. */
export const inDocPalette = isDark => ({
  bg: isDark ? '#070b14' : '#f4f7fb',
  grid: isDark ? '#1a2438' : '#d5deea',
  label: isDark ? '#f1f5f9' : '#0f172a',
  muted: isDark ? '#64748b' : '#64748b',
  sky: isDark ? '#38bdf8' : '#0284c7',
  skySoft: isDark ? '#7dd3fc' : '#0ea5e9',
  indigo: isDark ? '#818cf8' : '#4f46e5',
  amber: isDark ? '#fbbf24' : '#d97706',
  emerald: isDark ? '#34d399' : '#059669',
  rose: isDark ? '#fb7185' : '#e11d48',
  panel: isDark ? '#0c1220' : '#ffffff',
  panelFill: isDark ? 'rgba(12, 18, 32, 0.92)' : 'rgba(255, 255, 255, 0.96)',
  panelStroke: isDark ? '#2a3a55' : '#b6c4d8',
  accent: isDark ? '#38bdf8' : '#0284c7',
  accentSoft: isDark ? '#7dd3fc' : '#0ea5e9',
  mono: isDark ? '#7dd3fc' : '#0369a1',
});

export const inDocType = {
  section: {
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: '0.28em',
  },
  title: {
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.06em',
  },
  sub: {
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSize: 9,
    fontWeight: 500,
  },
  mono: {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontSize: 9,
    fontWeight: 500,
    letterSpacing: '0.04em',
  },
  monoSm: {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontSize: 8,
    fontWeight: 500,
    letterSpacing: '0.03em',
  },
};
